module.exports = __webpack_public_path__ + "img/user_video_icon.3ff244bd.svg";